export const COUPONS_CONFIG = {
    brand: {
        key: "brand",
        label: "Marca",
    },
    code: {
        key: "code",
        label: "Código",
    },
    expDate: {
        key: "expDate",
        label: "Fecha de expiración",
    },
    status: {
        key: "status",
        label: "Estatus",
    },
    discount: {
        key: "discount",
        label: "Descuento",
    },
    minPurchase: {
        key: "minPurchase",
        label: "Mínimo de compra",
    },
    page: {
        table: {
            actions: {
                edit: 'Editar',
                delete: 'Eliminar'
            }
        }
    },
};


export const COUPONS_PHRASE = {
    page: {
        table: {
            title: "Catalogo de Cupones",
            actions: {
                edit: 'Editar',
                delete: 'Eliminar'
            }
        }
    },
    modal: {
        titles: {
            edit: "Modificar cupón",
            add: "Crear cupón",
            delete: "¿Estas seguro de eliminar este cupón?"
        },
        actions: {
            cancel: "Cancelar",
            add: "Agregar",
            delete: "Eliminar",
            save: "Guardar"
        }
    },
    search: {
        messages: {
            noStations: "No se ha seleccionado alguna planta.",
        }
    }
}
